/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_ActiveInputs */

const en_subscription_active = /** @type {(inputs: Subscription_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const fr_subscription_active = /** @type {(inputs: Subscription_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actif`)
};

const de_subscription_active = /** @type {(inputs: Subscription_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

const it_subscription_active = /** @type {(inputs: Subscription_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attivo`)
};

const ru_subscription_active = /** @type {(inputs: Subscription_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активный`)
};

const es_subscription_active = /** @type {(inputs: Subscription_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activo`)
};

const zh_cn2_subscription_active = /** @type {(inputs: Subscription_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积极的`)
};

const ja_subscription_active = /** @type {(inputs: Subscription_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティブ`)
};

const hi_subscription_active = /** @type {(inputs: Subscription_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रिय`)
};

const pt_pt2_subscription_active = /** @type {(inputs: Subscription_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativo`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Subscription_ActiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_active = /** @type {((inputs?: Subscription_ActiveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_ActiveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subscription_active(inputs)
	if (locale === "de") return de_subscription_active(inputs)
	if (locale === "it") return it_subscription_active(inputs)
	if (locale === "ru") return ru_subscription_active(inputs)
	if (locale === "es") return es_subscription_active(inputs)
	if (locale === "zh-CN") return zh_cn2_subscription_active(inputs)
	if (locale === "ja") return ja_subscription_active(inputs)
	if (locale === "hi") return hi_subscription_active(inputs)
	if (locale === "pt-PT") return pt_pt2_subscription_active(inputs)
	return en_subscription_active(inputs)
});